<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_5"></a>Without the inspiration of Jack Vance, Hayao Miyazaki,<br/>and Talbot Mundy, there would be no book.</p>
<p class="dedication1">Without the able and expert assistance of Chris Cornuelle,<br/>Chris Weuve, Martin Helsdon, Loma Griffith, Teresita Flores,<br/>and Suzanne MacDhomhail, the story would be far poorer.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter002.vue?5d24a962